import { DataService } from "../../libs/services/index.js";

export class SupabaseConfig {
  instance;
  queue = [];
  offlineCallback = [];
  dbName = "";

  async loadModule() {
    const module = await import("@supabase/supabase-js");
    return module;
  }

  async getToken(accountId) {
    const [getTokenRequest] = DataService.get(
      `/notification/2/${accountId}/token`
    );

    let { custom_token: customToken } = await getTokenRequest();
    return customToken;
  }

  handleOfflineCallbacks = () => {
    if (document.visibilityState === "visible") {
      this.offlineCallback.forEach((callback) => {
        callback(true);
      });
    }
  };

  reconnectSync() {
    window.addEventListener("online", this.handleOfflineCallbacks);

    document.addEventListener("visibilitychange", this.handleOfflineCallbacks);
  }

  signout() {
    this.instance.removeAllSubscriptions();
    localStorage.setItem("isSessionExpired", true);
    window.removeEventListener("online", this.handleOfflineCallbacks);
    document.removeEventListener(
      "visibilitychange",
      this.handleOfflineCallbacks
    );
  }

  async init(accountId, config) {
    let customToken = await this.getToken(accountId);
    let supabase = await this.loadModule();
    this.instance = supabase.createClient(config.authDomain, config.apiKey); // v1

    this.dbName = config.databaseURL;

    this.instance.auth.setAuth(customToken);

    this.queue.forEach((item) => {
      let path = config.databaseURL + item.path;

      // NOTE: since supabase, doesn't support, offline sync. so triggering it by manual of online events
      if (item.path.includes(".info/connected")) {
        this.offlineCallback.push(item.callback);
      }

      this.instance
        .from(path)
        .on("*", (data) => {
          item.callback(data.new.Value);
        })
        .subscribe();
      item.callback(undefined);
    });

    this.reconnectSync();
    this.queue = [];

    return this.instance;
  }

  subscribe({ accountId, module, subModule, subModuleInstance }) {
    let subscribes = [];
    let path;

    path = [accountId, module, subModule, subModuleInstance]
      .filter(Boolean)
      .join("/");

    let channel = `:id=eq.${path}`;

    return {
      on: (eventName, callback) => {
        if (this.instance) {
          let _subscribe = this.instance
            .from(`${this.dbName}${channel}`)
            .on("*", (data) => {
              callback(data.new.Value || {});
            })
            .subscribe();

          subscribes.push(_subscribe);

          callback(undefined);

          if (path === ".info/connected") {
            this.offlineCallback.push(callback);
          }
        } else {
          this.queue.push({ path: channel, callback });
        }
      },
      once: (eventName, callback) => {
        if (this.instance) {
          let _subscribe = this.instance
            .from(`${this.dbName}${channel}`)
            .on("*", (data) => {
              callback(data.new.Value || {});
              this.instance.removeSubscription(_subscribe);
            })
            .subscribe();
        } else {
          this.queue.push(callback);
        }
      },

      off: () => {
        subscribes.forEach((subscribe) => {
          this.instance.removeSubscription(subscribe);
        });
      }
    };
  }
}
